/* eslint-disable no-param-reassign */
/* eslint-disable import/no-unresolved */
import { createAction, createReducer } from 'utils/reducer';

// Local constants
const PATH = 'warehouses/';
const DISABLE_ERRORS = `${PATH}DISABLE_ERRORS`;
const TOGGLE_FORM = `${PATH}TOGGLE_FORM`;
const CHANGE_CONTROLS = `${PATH}CHANGE_CONTROLS`;
const TOGGLE_DELETE = `${PATH}TOGGLE_DELETE`;
const TOGGLE_EDIT_WAREHOUSE = `${PATH}TOGGLE_EDIT_WAREHOUSE`;
const SET_INVALID_CONTROLS = `${PATH}SET_INVALID_CONTROLS`;

// Global constants for saga
export const WAREHOUSES = {
  CREATE_WAREHOUSE: `${PATH}CREATE_WAREHOUSE`,
  CREATE_WAREHOUSE_SUCCESS: `${PATH}CREATE_WAREHOUSE_SUCCESS`,
  GET_STATE_FROM_API: `${PATH}GET_STATE_FROM_API`,
  GET_STATE_FROM_API_SUCCESS: `${PATH}GET_STATE_FROM_API_SUCCESS`,
  DELETE_WAREHOUSE: `${PATH}DELETE_WAREHOUSE`,
  DELETE_WAREHOUSE_SUCCESS: `${PATH}DELETE_WAREHOUSE_SUCCESS`,
  EDIT_WAREHOUSE_SUCCESS: `${PATH}EDIT_WAREHOUSE_SUCCESS`,
  EDIT_WAREHOUSE: `${PATH}EDIT_WAREHOUSE`,
  EXPORT_WAREHOUSE: `${PATH}EXPORT_WAREHOUSE`,
  EXPORT_WAREHOUSE_SUCCESS: `${PATH}EXPORT_WAREHOUSE_SUCCESS`,
};

// actions
export const warehousesActions = {
  disableErrors: createAction(DISABLE_ERRORS),
  toggleForm: createAction(TOGGLE_FORM, 'modal'),
  changeControls: createAction(CHANGE_CONTROLS, 'controls', 'invalidControls'),
  toggleDelete: createAction(TOGGLE_DELETE, 'id'),
  toggleEdit: createAction(TOGGLE_EDIT_WAREHOUSE, 'item'),
  setInvalidControls: createAction(SET_INVALID_CONTROLS, 'controls'),
  // api
  getStateFromApi: createAction(WAREHOUSES.GET_STATE_FROM_API),
  createWarehouse: createAction(WAREHOUSES.CREATE_WAREHOUSE, 'controls'),
  editWarehouse: createAction(WAREHOUSES.EDIT_WAREHOUSE, 'id', 'controls'),
  deleteWarehouse: createAction(WAREHOUSES.DELETE_WAREHOUSE, 'id'),

  exportWarehouses: createAction(WAREHOUSES.EXPORT_WAREHOUSE),
};

const defaultInvalidInputs = {
  name: false,
  code: false,
};

const defaultFormControls = {
  name: '',
  code: '',
  supplyWarehouse: false,
};

const initialState = {
  formControls: { ...defaultFormControls },
  invalidControls: {
    ...defaultInvalidInputs,
  },
  formIsOpen: false,
  deleteIsOpen: false,
  toDeleteId: '',
  toEditId: '',
  edit: false,
  error: false,
};

const warehouses = createReducer(initialState, {
  [DISABLE_ERRORS](state, action) {
    state.error = false;
  },
  [TOGGLE_FORM](state, action) {
    state[action.modal] = !state[action.modal];
    state.edit = false;
    state.formControls = { ...defaultFormControls };
    state.invalidControls = { ...defaultInvalidInputs };
  },
  [CHANGE_CONTROLS](state, action) {
    state.formControls = {
      ...state.formControls,
      ...action.controls,
    };
    state.invalidControls = {
      ...state.invalidControls,
      ...(action.invalidControls || {}),
    };
  },
  [TOGGLE_DELETE](state, action) {
    state.deleteIsOpen = !state.deleteIsOpen;
    state.toDeleteId = action.id;
  },
  [TOGGLE_EDIT_WAREHOUSE](state, action) {
    state.formIsOpen = true;
    state.toDeleteId = '';
    state.toEditId = action.item.id;
    state.formControls.name = action.item.name;
    state.formControls.code = action.item.code;
    state.formControls.supplyWarehouse = action.item.supplyWarehouse;
    state.edit = true;
  },
  [SET_INVALID_CONTROLS](state, action) {
    state.invalidControls = {
      ...state.invalidControls,
      ...action.controls,
    };
  },
  // api
  [WAREHOUSES.CREATE_WAREHOUSE_SUCCESS](state, action) {
    state.formIsOpen = false;
    state.formControls = { ...defaultFormControls };
    state.invalidControls = { ...defaultInvalidInputs };
  },
  [WAREHOUSES.DELETE_WAREHOUSE_SUCCESS](state, action) {
    state.deleteIsOpen = false;
    state.toDeleteId = '';
  },
  [WAREHOUSES.EDIT_WAREHOUSE_SUCCESS](state, action) {
    state.formControls = { ...defaultFormControls };
    state.invalidControls = { ...defaultInvalidInputs };
    state.formIsOpen = false;
    state.toDeleteId = '';
    state.toEditId = '';
    state.edit = false;
  },
});

export default warehouses;
